export const getAuctions = async (searchString?: string): Promise<any> => {
  return await Promise.resolve([
    {
      id: 1,
      name: 'Auction Name #1',
      auctioneer: 'Auctioneer #1',
    },
    {
      id: 2,
      name: 'Auction Name #2',
      auctioneer: 'Auctioneer #2',
    },
  ]);
  // const response = await fetch(`/auctions?q=${searchString}`, {
  //   mode: 'cors',
  //   cache: 'no-cache',
  //   credentials: 'same-origin',
  //   headers: {
  //     Accept: 'application/json',
  //     'Content-Type': 'application/json',
  //   },
  //   redirect: 'follow',
  //   referrerPolicy: 'no-referrer'
  // });

  // return await response.json();
};
